import React from 'react';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { withRouter } from "react-router-dom";

const segments = [
	{ key: 'condos', label: 'Condos & Co-ops' },
	{ key: 'rental', label: 'Rentals' },
	{ key: 'multi-family', label: 'Multi-Family' },
	{ key: 'commercial', label: 'Commercial' },
	{ key: 'vacant-land', label: 'Vacant Land' },
	{ key: 'other', label: 'All Buildings' },
];

const getThemeColor = () => {
	if (document.querySelector('.role-bhs-agent')) return '#000000';
	if (document.querySelector('.role-elliman-agent')) return '#0e1028';
	return '#780F9E';
};

const SegmentSelector = ({ activeSegment, history }) => {
	const primaryColor = getThemeColor();
	const isMobile = useMediaQuery('(max-width: 768px)');

	const handleClick = (segmentKey) => {
		if (segmentKey !== activeSegment) {
			history.push(`/buildings/${segmentKey}`);
		}
	};

	if (isMobile) {
		return (
			<div style={{ marginBottom: 12, padding: '12px 16px 0' }}>
				<Select
					value={activeSegment}
					onChange={(e) => handleClick(e.target.value)}
					disableUnderline
					fullWidth
					style={{
						fontSize: 14,
						fontWeight: 600,
						color: primaryColor,
						textTransform: 'uppercase',
					}}
					MenuProps={{
						PaperProps: {
							style: { marginTop: 4 },
						},
						MenuListProps: {
							disablePadding: true,
						},
					}}
				>
					{segments.map(seg => (
						<MenuItem
							key={seg.key}
							value={seg.key}
							style={{
								fontSize: 14,
								fontWeight: activeSegment === seg.key ? 600 : 400,
								color: activeSegment === seg.key ? primaryColor : undefined,
								textTransform: 'uppercase',
								backgroundColor: 'transparent',
							}}
						>
							{seg.label}
						</MenuItem>
					))}
				</Select>
			</div>
		);
	}

	return (
		<div style={{ display: 'flex', marginBottom: 12, borderBottom: '2px solid #e8e8e8' }}>
			{segments.map(seg => (
				<Button
					key={seg.key}
					onClick={() => handleClick(seg.key)}
					style={{
						borderRadius: 0,
						borderBottom: activeSegment === seg.key ? `3px solid ${primaryColor}` : '3px solid transparent',
						color: activeSegment === seg.key ? primaryColor : '#646777',
						fontWeight: activeSegment === seg.key ? 600 : 400,
						fontSize: 15,
						textTransform: 'uppercase',
						padding: '8px 20px',
						minWidth: 0,
						marginBottom: -2,
					}}
				>
					{seg.label}
				</Button>
			))}
		</div>
	);
};

export default withRouter(SegmentSelector);
